import React from "react";

const SearchBox = ({
  name,
  value,
  onChange,
  clearSearch,
  placeholder,
  label,
  divClassName,
  noBorder,
  borderClassName,
  style,
  ...rest
}) => {
  return (
    <div className={divClassName}>
      {label ? (
        <label
          htmlFor={`${name !== undefined ? name : "query"}`}
          className="mt-0 form-label"
        >
          {label}
        </label>
      ) : null}

      <div
        className={
          noBorder === true
            ? "d-print-none d-flex align-items-center mx-1 pe-2 rounded bg-white"
            : `d-print-none d-flex align-items-center mx-1 pe-2 ${
                borderClassName ? borderClassName : "safy-border-2 border-info"
              } rounded bg-white`
        }
        style={style}
      >
        <input
          type="text"
          name={`${name !== undefined ? name : "query"}`}
          className="flex-grow-1 py-2 rounded"
          style={{ border: "none", boxShadow: "none", outline: "none" }}
          placeholder={placeholder || "Search"}
          value={value}
          onChange={onChange}
          {...rest}
        />
        {clearSearch && (
          <div className="ms-2 d-flex align-items-center">
            <i
              className="fas fa-times-circle fa-lg text-danger p-0 m-0"
              onClick={clearSearch}
            ></i>
          </div>
        )}
      </div>
      <div className="d-none d-print d-flex align-items-center mx-1 pe-2 rounded bg-white">
        <input
          type="text"
          name={`${name !== undefined ? name : "query"}`}
          className="flex-grow-1 rounded"
          style={{ border: "none", boxShadow: "none", outline: "none" }}
          placeholder={placeholder || "Search"}
          value={value}
          onChange={onChange}
          {...rest}
        />
        {clearSearch && (
          <div className="ms-2">
            <i
              className="fas fa-times-circle fa-lg text-danger p-0 m-0"
              onClick={clearSearch}
            ></i>
          </div>
        )}
      </div>
    </div>
  );
};

export default SearchBox;
